export const getBuildID = t => {
  try {
    return navigator.buildID || t("global.notSupported");
  } catch {
    return t("global.notSupported");
  }
};
